export default __webpack_public_path__ + "1e7d3d4.png";